<template lang="pug">
  AppLayout(:title="title")
    Card(title="Available Exports", :noPadding="true")
      div.divide-y.divide-gray-200
        div.flex.items-center.justify-between.p-6(v-for="download in downloads" :key="download.url")
          div
            div.font-bold.text-lg.text-heading {{ download.title }}
            div.text-sm {{ download.description }}
          Button(@click="exportToCsv(download.title, download.endpoint)", type="primary", prepend-icon="download") Download
</template>

<script>
import ExportToCsvModal from "../../modals/Export/ExportToCsvModal.vue"

export default {
  metaInfo() {
    return { title: this.title }
  },
  data: () => ({
    title: "Export",
    downloads: []
  }),
  async created() {
    let { data } = await this.$api.get("exports")
    this.downloads = data?.exports || []
  },
  methods: {
    async exportToCsv(title, endpoint) {
      await this.$modal.show(ExportToCsvModal, { title, endpoint })
    }
  }
}
</script>
